import React from "react";

import { useTranslation } from "next-i18next";

import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";

import Globe from "~public/images/Globe.svg";
import TwoLines from "~public/images/searchpage/two-lines.svg";

export const UniteRecipesSection = (props: any): JSX.Element => {
  const { t } = useTranslation("searchpage");
  const theme = useTheme();
  const isGreaterThanTablet = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Box
      sx={{
        px: 3,
        py: 2,
        bgcolor: "orange.main"
      }}>
      <Box
        sx={{
          maxWidth: { md: "1180px" },
          margin: { md: "0 auto" },
          display: "flex",
          justifyContent: "space-between",
          gap: 1.25,
          position: "relative",
          height: { xs: 230, md: 480 }
        }}>
        <Box sx={{ alignSelf: "start", mt: 2, zIndex: 1 }}>
          <Typography
            sx={{
              alignSelf: "start",
              fontSize: { xs: 28, md: 96 }
            }}
            fontWeight={500}
            // fontSize={28}
          >
            {t("unite-section.text1")}
          </Typography>
          <Typography
            sx={{
              alignSelf: "start",
              fontSize: { xs: 28, md: 96 }
            }}
            fontWeight={500}
            // fontSize={28}
            color={"white.main"}
            // textTransform={"lowercase"}
          >
            {t("unite-section.text2")}
          </Typography>
        </Box>
        <Box sx={{ alignSelf: "end", zIndex: 1 }}>
          <Typography
            sx={{
              textAlign: "end",
              fontSize: { xs: 28, md: 96 }
            }}
            fontWeight={500}
            // fontSize={28}
            color={"white.main"}>
            {t("unite-section.text3")}
          </Typography>
          <Box position={"relative"}>
            <Typography
              sx={{
                textAlign: "end",
                mb: 2,
                fontSize: { xs: 28, md: 96 }
              }}
              fontWeight={500}
              // fontSize={28}
              // textTransform={"lowercase"}
            >
              {t("unite-section.text4")}
            </Typography>
            <Box position={"absolute"} sx={{ top: 30, left: 0 }}>
              <TwoLines style={{ width: 150, height: 40 }} />
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            zIndex: 0,
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            "& path": {
              fill: "white"
            }
          }}>
          <Globe style={{ fontSize: isGreaterThanTablet ? 375 : 160 }} />
        </Box>
      </Box>
    </Box>
  );
};
